import './assets/js/common';
import './assets/js/mobile-menu';
import './assets/js/videoPlayScroll';
import './assets/js/scrollHeader';
import './assets/js/logo';



// WEBPACK FOOTER //
// ./app/index.js